module.exports = __webpack_public_path__ + "img/management-function-1.95e3e468.png";